import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  listIcon: {
    minWidth: 26,
  },
  listText: {
    fontFamily: theme.font.regular,
  },
  paper: {
    borderRadius: 5,
  },
  profileDetailsWrapper: {
    width: 245,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.defaultLightGrey,
  },
  userName: {
    fontFamily: theme.font.medium,
  },
  positionDropdown: {
    width: 100,
  },
  role: {
    fontFamily: theme.font.secondary,
  },
}));
